import React from 'react'
import { VscFilePdf, VscFileZip, VscFile } from 'react-icons/vsc';

const BYTE = 1000;
const getKB = (bytes) => Math.round(bytes / BYTE);

const FileIcon = ({ children }) => {
    return <span className="text-4xl">{children}</span>;
};

const FileItem = (props) => {
    const { file, children } = props;
    const { type, name, size } = file;

    const renderThumbnail = () => {
        const isImageFile = type?.split('/')[0] === 'image';

        if (isImageFile) {
            return (
                <span className="w-10 h-10 bg-[#FF8E1C] border-4 border-blue-50 flex items-center rounded-full justify-center mr-3">
                    <img src="/assets/icons-svg/image-01.svg" alt="image icon" />
                </span>
            );
        }

        if (type === 'application/zip') {
            return (
                <FileIcon>
                    <span className="w-10 h-10 bg-[#FF8E1C] border-4 border-blue-50 flex items-center rounded-full justify-center mr-3">
                        <img src="/assets/icons-svg/upload-pdf.svg" alt="zip icon" />
                    </span>
                </FileIcon>
            );
        }

        if (type === 'application/pdf') {
            return (
                <FileIcon>
                    <span className="w-10 h-10 bg-[#FF8E1C] border-4 border-blue-50 flex items-center rounded-full justify-center mr-3">
                        <img src="/assets/icons-svg/upload-pdf.svg" alt="pdf icon" />
                    </span>
                </FileIcon>
            );
        }

        return (
            <FileIcon>
                <span className="w-10 h-10 bg-[#FF8E1C] border-4 border-blue-50 flex items-center rounded-full justify-center mr-3">
                    <img src="/assets/icons-svg/film.svg" alt="file icon" />
                </span>
            </FileIcon>
        );
    };
const openFileInNewTab = (file) => {
    let fileURL;

    if (file instanceof File || file instanceof Blob) {
        fileURL = URL.createObjectURL(file);
    } else if (file.url) {
        fileURL = file.url; // Use existing URL
    } else {
        console.error("Cannot open file: invalid file object", file);
        return;
    }

    window.open(fileURL, "_blank");

    // Only revoke URL if we created it from a File
    if (file instanceof File || file instanceof Blob) {
        setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
    }
};



    // return (
    //     <div className="upload-file">
    //         <div className="flex">
    //             <div className="upload-file-thumbnail">{renderThumbnail()}</div>
    //             <div className="upload-file-info">
    //                 <h6 className="upload-file-name font-medium text-xs text-gray-700">{name}</h6>
    //                 <span className="upload-file-size text-xs text-gray-600">
    //                     {getKB(size)} KB - 100% uploaded
    //                 </span>
    //             </div>
    //         </div>
    //         {children}
    //     </div>
    // );
    return (
    <div className="upload-file">
        <div
            className="flex cursor-pointer"
            onClick={() => openFileInNewTab(file)}
        >
            <div className="upload-file-thumbnail">
                {renderThumbnail()}
            </div>

            <div className="upload-file-info">
                <h6 className="upload-file-name font-medium text-xs text-gray-700">
                    {name}
                </h6>
                <span className="upload-file-size text-xs text-gray-600">
                    {getKB(size)} KB - 100% uploaded
                </span>
            </div>
        </div>

        {children}
    </div>
);


};

export default FileItem;
